import dayjs from "dayjs";
import updateLocale from "dayjs/plugin/updateLocale";
import "dayjs/locale/ko";
import antdKoKR from "antd/locale/ko_KR";
import antdLibKoKR from "antd/lib/locale/ko_KR";
import antdEsKoKR from "antd/es/locale/ko_KR";

dayjs.extend(updateLocale);
dayjs.locale("ko");
dayjs.updateLocale("ko", { weekStart: 0 });

const SUNDAY_WEEK_DAYS = ["일", "월", "화", "수", "목", "금", "토"];

function patchLang(lang) {
	if (!lang) {
		return;
	}
	lang.weekStart = 0;
	lang.shortWeekDays = SUNDAY_WEEK_DAYS;
}

function patchAntdLocale(locale) {
	if (!locale) {
		return locale;
	}
	patchLang(locale.DatePicker?.lang);
	patchLang(locale.Calendar?.lang);
	patchLang(locale.lang);
	return locale;
}

patchAntdLocale(antdKoKR);
patchAntdLocale(antdLibKoKR);
patchAntdLocale(antdEsKoKR);

export const antdKoKRSunday = antdKoKR;
export default antdKoKR;
